import script from "./saleContractDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./saleContractDetail.vue?vue&type=script&setup=true&lang=js"

import "./saleContractDetail.vue?vue&type=style&index=0&id=9ae27a8e&lang=less"

const __exports__ = script;

export default __exports__